module.exports = __webpack_public_path__ + "static/img/contactus.ffe7a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-500/contactus.jpg
// module id = 5ocY
// module chunks = 1